import React, { Component } from "react";
import RenderTable from "../common/table";
import { Icon } from "semantic-ui-react";
import auth from "../../services/authService";

class BankTable extends Component {
  columns = [
    {
      path: "name",
      label: "Name",
      width: "2"
    },
    {
      path: "address",
      label: "Address",
      width: "3"
    },
    {
      path: "phone",
      label: "Phone",
      width: "2"
    },
    {
      path: "account",
      label: "Account",
      width: "2"
    },
    {
      path: "account_title",
      label: "Account Title",
      width: "2"
    },
    {
      path: "iban",
      label: "IBAN",
      width: "1"
    },
    {
      path: "branch_name",
      label: "Branch",
      width: "1"
    },
    {
      path: "branch_code",
      label: "Code",
      width: "1"
    },

    {
      key: "actions",
      width: "2",
      content: type =>
          <div>
      {auth.getCurrentUser().email === "company-unblocker@gondalgroup.ae" && (
      
            <Icon
              name="trash"
              color="red"
              className="clickable"
              onClick={() => this.props.onDelete(type)}
            />
            )}

            <Icon
              name="edit"
              color="blue"
              className="clickable"
              onClick={() => this.props.onUpdate(type)}
            />
          </div>
        
    }
  ];

  render() {
    const { types, onSort, sortColumn } = this.props;

    return (
      <RenderTable
        columns={this.columns}
        data={types}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default BankTable;
